import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { LoggerService } from 'src/app/services/logger/logger.service';

export const missingTranslationPrefix = 'Missing translation';
@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  public constructor(
    private loggerService: LoggerService,
  ) { }

  public handle(params: MissingTranslationHandlerParams): string {
    // todo (? - probably not necessary) - add context / selected language for missing translation
    this.loggerService.error(`Missing translation with key ${params.key}`);
    return `[${missingTranslationPrefix}: ${params.key}]`;
  }
}
